export default "__VITE_ASSET__BRiNIx$g__"